import React from 'react'
import classNames from 'classnames'

import styles from './MetadataList.module.scss'

export interface MetadataItem {
  label?: string
  value: string | React.ReactNode
}

export interface MetadataListProps {
  divider?: boolean
  isTruncated?: boolean
  items: MetadataItem[]
  prefix?: string
}

const MetadataList: React.FC<MetadataListProps> = ({
  items,
  divider = false,
  isTruncated,
  prefix = '',
}) => (
  <div
    className={classNames({
      [styles.divider]: divider,
      [styles.truncation]: isTruncated,
    })}
  >
    {prefix}
    {items
      .filter((item) => item.value)
      .map((item, index) => {
        // Create a stable key based on the original item data
        const key = item.label
          ? `${item.label}-${typeof item.value === 'string' ? item.value : 'react-node'}`
          : typeof item.value === 'string'
            ? item.value
            : `item-${index}`

        const displayValue =
          typeof item.value === 'string'
            ? item.label
              ? `${item.label}: ${item.value}`
              : item.value
            : item.value

        return (
          <React.Fragment key={key}>
            <span>{displayValue}</span>
            {index < items.filter((item) => item.value).length - 1 && (
              <span className={styles.dot}>•</span>
            )}
          </React.Fragment>
        )
      })}
  </div>
)

export default MetadataList
